// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".goods-cate-modal-body[data-v-3b932274] {\n  border-bottom: 1px solid #e1e4eb;\n}\n.goods-cate-modal-body .actions-btn[data-v-3b932274] {\n  margin-bottom: 24px;\n}\n.goods-cate-modal-footer[data-v-3b932274] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 80px;\n}", ""]);
// Exports
module.exports = exports;
